// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es7.weak-set.from.js
// module id = 3ir/
// module chunks = 1